import Controller from "../controller/Controller";
import {MerchantConfig} from "../types/response/MerchantConfig";
import {ServerResultHandler} from "../handleServerResult";
import {UserActionType} from "../types/UserAction";

export class MerchantConfigLoader {

    private _configPromise?: Promise<MerchantConfig>

    constructor(
        private readonly _controller: Controller,
        private readonly _serverResultHandler: ServerResultHandler
    ) {
    }

    load(): Promise<MerchantConfig> {
        if (!this._configPromise) {
            this._configPromise = this.doLoad()
        }
        return this._configPromise
    }

    private doLoad(): Promise<MerchantConfig> {
        return this._controller.action(UserActionType.GET_MERCHANT_CONFIG, {})
            .then(this._serverResultHandler.handleNoTrackCallback())
            .catch(err => {
                console.error("Failed to load merchant config, falling back to defaults", err)
                return {}
            })
    }
}